var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteCollectionFolder = function SvgGradientWhiteCollectionFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.904 2.06a213.46 213.46 0 0 0-5.906-.081A407.37 407.37 0 0 1 6.554.42a1.237 1.237 0 0 0-.932-.402c-1.153.018-2.306.05-3.46.095A1.436 1.436 0 0 0 .814 1.457a129.906 129.906 0 0 0-.113 4.505c4.864-.034 9.729-.034 14.593 0-.007-.858-.022-1.716-.046-2.574-.02-.71-.626-1.306-1.344-1.327Z",
    fill: "#fff",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.713 3.346c-.017.868-.028 1.736-.033 2.604 3.545-.018 7.09-.018 10.637 0-.005-.868-.016-1.736-.034-2.604a293.48 293.48 0 0 0-10.57 0Z",
    fill: "url(#gradient-white-collection-folder_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.889 2.055C9.379 2 7.87 1.973 6.36 1.973A386.07 386.07 0 0 1 5.254.42C5.07.16 4.811.013 4.54.02c-.884.018-1.768.05-2.652.095C1.344.142.878.745.854 1.453a168.428 168.428 0 0 0-.086 4.492c3.729-.033 7.457-.033 11.186 0a169.01 169.01 0 0 0-.035-2.567c-.015-.708-.48-1.302-1.03-1.323Z",
    fill: "url(#gradient-white-collection-folder_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.701 5.962c-.018 2.317.026 4.634.132 6.95a.962.962 0 0 0 .9.897c4.176.176 8.353.176 12.529 0a.962.962 0 0 0 .9-.896c.106-2.317.15-4.634.132-6.951-.006-.71-.606-1.296-1.332-1.306a461.769 461.769 0 0 0-11.929 0c-.726.01-1.326.596-1.332 1.306Z",
    fill: "url(#gradient-white-collection-folder_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-collection-folder_svg__a",
    x1: 7.99,
    y1: 3.298,
    x2: 7.99,
    y2: 4.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-collection-folder_svg__b",
    x1: 6.242,
    y1: 1.241,
    x2: 5.928,
    y2: 7.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-collection-folder_svg__c",
    x1: 7.842,
    y1: 6.541,
    x2: 7.247,
    y2: 16.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
};

export default SvgGradientWhiteCollectionFolder;